
import React from 'react';
import { Quote, Star } from 'lucide-react';

const testimonials = [
  {
    name: "Mike Henderson",
    company: "Henderson Tree & Land",
    location: "Macon, GA",
    metric: "+$18,400 Monthly Revenue",
    timeframe: "First 60 Days",
    quote: "I was skeptical because I've been burned by 'lead gen' guys before. I was a solo climber doing my own sales. I was missing 4-5 calls a day while I was in the tree. Once we turned on the Arbor Advantage 'Missed Call Text Back' and the auto-quotes, my closing rate jumped from 20% to 55%. It's like having a full-time secretary in my pocket for a fraction of the cost.",
    hesitation: "Worried it would be too 'techy' for a guy like me."
  },
  {
    name: "Steve 'Big Tex' Miller",
    company: "Lone Star Arborists",
    location: "Austin, TX",
    metric: "12 New Jobs per Week",
    timeframe: "90 Days",
    quote: "We were already doing okay, but our follow-up was non-existent. We'd give an estimate and never call them again. Arbor Advantage automated the follow-up sequence. Now, customers get a text 2 hours, 2 days, and 5 days after the quote. We're booking jobs we would have completely forgotten about. It added $22k to our bottom line without me buying a single new piece of gear.",
    hesitation: "Didn't think automated texts would feel 'personal' enough."
  },
  {
    name: "Chris Vance",
    company: "Vance Family Tree Care",
    location: "Columbus, OH",
    metric: "3x More 5-Star Reviews",
    timeframe: "45 Days",
    quote: "The review generator alone paid for the system. In the tree business, your reputation is everything. Now, the second we finish a job, the system texts the client a link. My Google ranking went from Page 3 to Top 3 in less than two months. My phone doesn't stop ringing now. If you're running a crew and not using this, you're just making it harder on yourself.",
    hesitation: "Thought my existing Facebook page was enough."
  }
];

const Testimonials: React.FC = () => {
  return (
    <section className="py-24 bg-white text-[#0F1419]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-7xl font-black mb-4 uppercase italic tracking-tighter">Real Dirt, Real Dollars.</h2>
          <p className="text-xl text-[#1A4D2E] font-black uppercase tracking-widest italic">Straight from the guys in the trucks.</p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {testimonials.map((t, i) => (
            <div key={i} className="bg-[#F4E4C1]/20 p-8 rounded-[2.5rem] border-2 border-[#4E3629]/10 relative group hover:shadow-2xl hover:border-[#1A4D2E] transition-all duration-500">
              <div className="absolute -top-4 -left-4 bg-[#1A4D2E] text-white p-3 rounded-xl shadow-lg group-hover:rotate-12 transition-transform">
                <Quote className="w-6 h-6" />
              </div>
              
              <div className="flex gap-1 mb-4">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-[#FF6B35] text-[#FF6B35]" />)}
              </div>

              <p className="text-lg font-bold mb-6 leading-relaxed italic">"{t.quote}"</p>
              
              <div className="mb-8">
                <p className="text-sm text-[#4E3629] italic"><span className="font-black text-[#1A4D2E] uppercase not-italic tracking-wider">Initial Doubt:</span> {t.hesitation}</p>
              </div>

              <div className="pt-6 border-t border-[#4E3629]/10">
                <p className="font-black text-2xl text-[#0F1419] uppercase tracking-tighter italic">{t.name}</p>
                <p className="text-sm text-[#4E3629] font-black opacity-60 uppercase tracking-widest">{t.company} • {t.location}</p>
                <div className="mt-4 inline-block bg-[#1A4D2E] text-white px-4 py-1.5 rounded-full text-[10px] font-black uppercase tracking-widest shadow-lg shadow-green-900/20">
                  {t.metric}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
